import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, withPrefix } from "gatsby";
import { ArrowRight } from "../Arrow";

const FilterPanels = ({ entity, filtersContent, listTitle, listSlug, listItems, 
  borderTopLeftRadius = true,
  borderBottomLeftRadius = true  }) => {
  
  const [filtersState, setFiltersState] = useState("collapsed");

  function getClassName() {
    let className = `is-${filtersState}`;
    if ( entity ) {
      className += " is-entity-view";
    }
    if ( ! borderTopLeftRadius ) {
      className += " has-no-top-left-border-radius";
    }
    if ( ! borderBottomLeftRadius ) {
      className += " has-no-bottom-left-border-radius";
    }
    return className;
  }

  function handleToggleCollapseExpand() {
    if ( filtersState === "collapsed" ) {
      if ( entity ) {
        setFiltersState("expanded");
      }
      else {
        setFiltersState("default");
      }
    }
    else if ( filtersState === "expanded" || filtersState === "default" ) {
      setFiltersState("collapsed");
    }
  }

  useEffect(() => {
    if ( entity ) {
      setFiltersState("collapsed")
    }
    else {
      setFiltersState("default");
    }
  }, [entity]);

  return (
    <StyledFilterPanels className={getClassName()}>
      <StyledFilterPanel className="filters-wrap--actions">
        <div className="actions">
          <button type="button" onClick={handleToggleCollapseExpand}>
            <span>{filtersState === "collapsed" ? "Show Filters" : "Hide Filters"}</span>
          </button>
        </div>
      </StyledFilterPanel>
      <StyledFilterPanel className="filters-wrap--filters">
        <StyledFilterPanelContent className="filters-wrap__filters">
          {filtersContent}
        </StyledFilterPanelContent>
      </StyledFilterPanel>
      <StyledFilterPanel className="filters-wrap--list">
        <StyledFilterPanelContent className="filters-wrap__list">
          <StyledSuppplyChainEntitySmallList className={entity ? "is-entity-view" : undefined}>
            <div className="meta">
              <strong>{listTitle}</strong>
              {listSlug.match(/^#/) ? (
                <a href={`#${listSlug}`} title="Expand">
                  <span className="label">Expand List</span>
                  <span className="icon"><ArrowRight /></span>
                </a>
              ) : (
                <Link to={listSlug} title="Expand List">
                  <span className="label">Expand List</span>
                  <span className="icon"><ArrowRight /></span>
                </Link>
              )}
            </div>
            <ol>
              {listItems}
            </ol>
          </StyledSuppplyChainEntitySmallList>
        </StyledFilterPanelContent>
      </StyledFilterPanel>
    </StyledFilterPanels>
  );
};

export default FilterPanels;


const StyledFilterPanelContent = styled.div`
  @media ( min-width: 70em ) {
    height: inherit;
    position: relative;
    //filter: drop-shadow(0 0 0.5em rgba(0,0,0,0.5));
    height: inherit;
    position: relative;

    background-color: #191919;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    &::-webkit-scrollbar {
      width: 12px;
      height: 12px;
    }
    &::-webkit-scrollbar-track {
      width: 12px;
      height: 12px;
      background-color: #222;
    }
    &::-webkit-scrollbar-thumb {
      height: 12px;
      width: 12px;
      background: #444;
      border: solid #222;
      border-width: 0 4px;
    }
    
    transition: transform 0.4s ease;

    .is-entity-view & {
      &.filters-wrap__filters {
        //> div {
          //> div {
            transform: translate3d(-100%,0,0);
          //}
        //}
      }
    }
    .is-expanded &.filters-wrap__filters {
      transform: translate3d(0,0,0);
    }
  }
`;

const StyledFilterPanel = styled.div`


  &.filters-wrap--actions,
  &.filters-wrap--list {
    display: none;
  }

  @media ( min-width: 70em ) {
    position: relative;
    height: inherit;
    transition: transform 0.4s ease;
    grid-row: 1;
    grid-column: 1;
    border-radius: 1em;
    .has-no-top-left-border-radius & {
      border-top-left-radius: 0;
    }
    .has-no-bottom-left-border-radius & {
      border-bottom-left-radius: 0;
    }
    contain: paint;
    &.filters-wrap--actions {
      contain: none;
      display: block;
    }
    &.filters-wrap--filters {
      //contain: paint;
      z-index: 5;
    }
    &.filters-wrap--list {
      display: block;
    }
    .is-entity-view & {
      &.filters-wrap--filters {
        z-index: 0;
        transition: z-index 0s linear 0.4s;
      }
    }
    .is-expanded & {
      &.filters-wrap--filters {
        border-radius: 1em 0 0 1em;
      }
      &.filters-wrap--list {
        transform: translate3d(100%,0,0);
        border-radius: 0 1em 1em 0;
      }
      &.filters-wrap--actions {
        transform: translate3d(100%,0,0);
      }
    }


    .has-no-top-left-border-radius &.filters-wrap--filters {
      border-top-left-radius: 0;
    }
    .has-no-bottom-left-border-radius &.filters-wrap--filters {
      border-bottom-left-radius: 0;
    }
    .is-default & {
      &.filters-wrap--actions {
        transform: translate3d(-2em,0,0);
      }
    }

    > .actions {
      position: absolute;
      top: 50%;
      left: 100%;
      transition: transform 0.4s ease;
      transform: translate3d(0,0,0);
      span {
        position: absolute;
        background-color: #999;
        color: var(--color-black);
        white-space: nowrap;
        font-size: 0.6875em;
        font-weight: 700;
        border-radius: 0.5em 0.5em 0 0;
        padding: 0.125em 0.75em 0.125em 0.5em;
        transform-origin: bottom center;
        width: 7em;
        height: 1.875em;
        line-height: 1.8;
        text-align: center;
        margin-left: -3.5em;
        transition: background-color 0.2s ease;
        transform: rotate(90deg) translate3d(-50%,0,0);

        .can-hover &:hover,
        &:active {
          background-color: #fff;
        }
      }
    }
  }

`;
const StyledFilterPanels = styled.div`
  @media ( max-width: 70em ) {
    position: static;

    .filters-wrap__list {
      display: none;
    }
  }
  @media ( min-width: 70em ) {
    position: sticky;
    display: grid;
    grid-template: auto / 6em 1fr;
    border-radius: 1em;
    top: calc((var(--navbar-height) + 77px) + 1.5em);
    height: calc(100vh - (var(--navbar-height) + 77px) - 3em);
    grid-template: 1fr / 1fr;
    z-index: 20;
    filter: drop-shadow(0 0 0.5em rgba(0,0,0,0.5));
  }
  
`;


const StyledSuppplyChainEntitySmallList = styled.div`
  background-color: inherit;
  position: relative;
  z-index: 5;
  padding: 0 1.5em 1.5em;
  background-color: inherit;
  @media ( max-width: 70em ) {
    display: none;
  }

  .meta {
    position: sticky;
    top: 0;
    padding: 0.875em 0 0.75em;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(255,255,255,0.5);
    background-color: inherit;
    margin-bottom: 1em;
    z-index: 2;
    @media ( max-width: 70em ) {
      padding: 0;
      height: 2.625em;
    }
    strong {
      font-size: 0.875em;
      font-weight: 700;
      opacity: 0.6;
      @media ( max-width: 70em ) {
        line-height: 1;
      }
    }
    a {
      display: flex;
      align-items: center;
      gap: 0.375em;
      opacity: 0.5;
      cursor: pointer;
      transition: opacity 0.2s ease;
      .can-hover &:hover,
      &:active {
        opacity: 1;
      }
      .label {
        font-size: 0.75em;
        font-weight: 500;
        line-height: 1;
      }
      .icon {
        font-size: 0.75em;
        line-height: 1;
      }
    }
  }
  ol {
    list-style: none;
    margin: 0;
    padding: 0;
  }
`;